import SupplierService from './supplier-service';

const MODULE_NAME = 'app.supplier';
const module = angular
    .module(MODULE_NAME, [])
    .service('supplierService', SupplierService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/supplier/supplier-module.js